<template>
    <div>
        <!-- Begin Page Content -->
        <div class="medical-records recommended-questionnaire">
            <div class="row">
                <div class="col-12 mb-4">
                    <div class="card border-0">
                        <div class="card-body p-0">
                            <div class="bg-white border-radius-5 p-4">
                                <div class="row no-gutters mb-4">
                                    <div class="col-md-12 pl-2">
                                        <h2>Recommended Questionnaire</h2>
                                    </div>
                                </div>
                                <div class="row no-gutters w-100 mb-4">
                                    <div class="col-md-3 Questionnaire-test pr-2 pl-2 d-flex align-items-center justify-content-center mb-4">
                                        <div class="Intake-Questionnaire border-1 border-radius-5 bg-white p-3 text-center">
                                            <i class="icon icon-report"></i>
                                            <h3 class="d-block">Adverse Childhood Experience (ACE)</h3>
                                            <ul class="d-flex justify-content-center align-items-center mt-3">
                                                <li><router-link to="/intake-questionaries-question" class="btn btn-link btn-blue Take-Assessment">Take Assessment</router-link ></li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="col-md-3 Questionnaire-test pr-2 pl-2 d-flex align-items-center justify-content-center mb-4">
                                        <div class="Intake-Questionnaire border-1 border-radius-5 bg-white p-3 text-center">
                                            <i class="icon icon-report"></i>
                                            <h3 class="d-block single-line">qADAM Questionnaire</h3>
                                            <ul class="d-flex justify-content-center align-items-center mt-3 submenu">
                                                <li>
                                                    <router-link to="/intake-questionaries-question" class="btn btn-link btn-gray edit p-0"><i class="icon icon-pencil"></i> </router-link>
                                                </li>
                                                <li>
                                                    <router-link to="/intake-questionaries-question" class="btn btn-link btn-gray edit p-0"><i class="icon icon-visibility"></i> </router-link>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div class="row no-gutters mb-4">
                                    <div class="col-md-12 pl-2">
                                        <h2>Related Questionnaire</h2>
                                    </div>
                                </div>
                                <div class="row no-gutters w-100 mb-4">
                                    <div class="col-md-3 Questionnaire-test pr-2 pl-2 d-flex align-items-center justify-content-center mb-4">
                                        <div class="Intake-Questionnaire border-1 border-radius-5 bg-white p-3 text-center">
                                            <i class="icon icon-report"></i>
                                            <h3 class="d-block single-line">Heart</h3>
                                            <ul class="d-flex justify-content-center align-items-center mt-3">
                                                <li><router-link to="/intake-questionaries-question" class="btn btn-link btn-gray Take-Assessment">Take Assessment</router-link ></li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="col-md-3 Questionnaire-test pr-2 pl-2 d-flex align-items-center justify-content-center mb-4">
                                        <div class="Intake-Questionnaire border-1 border-radius-5 bg-white p-3 text-center">
                                            <i class="icon icon-report"></i>
                                            <h3 class="d-block">Medical Symptoms Questionnaire</h3>
                                            <ul class="d-flex justify-content-center align-items-center mt-3">
                                                <li><router-link to="/intake-questionaries-question" class="btn btn-link btn-gray Take-Assessment">Take Assessment</router-link ></li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="col-md-3 Questionnaire-test pr-2 pl-2 d-flex align-items-center justify-content-center mb-4">
                                        <div class="Intake-Questionnaire border-1 border-radius-5 bg-white p-3 text-center">
                                            <i class="icon icon-report"></i>
                                            <h3 class="d-block single-line">PCOS Questionnaire</h3>
                                            <ul class="d-flex justify-content-center align-items-center mt-3">
                                                <li><router-link to="/intake-questionaries-question" class="btn btn-link btn-gray Take-Assessment">Take Assessment</router-link ></li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="col-md-3 Questionnaire-test pr-2 pl-2 d-flex align-items-center justify-content-center mb-4">
                                        <div class="Intake-Questionnaire border-1 border-radius-5 bg-white p-3 text-center">
                                            <i class="icon icon-report"></i>
                                            <h3 class="d-block single-line">Sated Questionnaire</h3>
                                            <ul class="d-flex justify-content-center align-items-center mt-3">
                                                <li><router-link to="/intake-questionaries-question" class="btn btn-link btn-gray Take-Assessment">Take Assessment</router-link ></li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="col-md-3 Questionnaire-test pr-2 pl-2 d-flex align-items-center justify-content-center mb-4">
                                        <div class="Intake-Questionnaire border-1 border-radius-5 bg-white p-3 text-center">
                                            <i class="icon icon-report"></i>
                                            <h3 class="d-block single-line">Gut Symptoms Questionnaire</h3>
                                            <ul class="d-flex justify-content-center align-items-center mt-3">
                                                <li><router-link to="/intake-questionaries-question" class="btn btn-link btn-gray Take-Assessment">Take Assessment</router-link ></li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="col-md-3 Questionnaire-test pr-2 pl-2 d-flex align-items-center justify-content-center mb-4">
                                        <div class="Intake-Questionnaire border-1 border-radius-5 bg-white p-3 text-center">
                                            <i class="icon icon-report"></i>
                                            <h3 class="d-block single-line">MDS Program Intake Form</h3>
                                            <ul class="d-flex justify-content-center align-items-center mt-3">
                                                <li><router-link to="/intake-questionaries-question" class="btn btn-link btn-gray Take-Assessment">Take Assessment</router-link ></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- End of Page Wrapper -->
    </div>
</template>
<script>
    export default {
        name: "Intake-questions",
        data() {
            return {};
        },
        created(){
           this.pageName('Intake Questionnaire')
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/website/questionaries/intake-questionaries.vue